import React, {useContext, useEffect, useState} from 'react';
import {Dropdown, Form, Spinner} from "react-bootstrap";
import {createAssType, createLanguage, fetchAssTypes, fetchLanguages} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";

const CreateAssignType = observer(({ show, handleClose }) => {
    const {book} = useContext(Context);

    const [atypeValue, setATypeValue] = useState('');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchAssTypes().then(data => book.setAssTypes(data))
    }, []);

    const addAssType = async () => {
        setLoading(true);
        setError('');
        try {
            await createAssType({ ass_type_name: atypeValue });
            const updatedAssTypes = await fetchAssTypes(); // Обновляем список жанров после изменения
            book.setAssTypes(updatedAssTypes);
            book.setSelectedAssType({}); // Сбрасываем выбранный жанр
            setATypeValue(''); // Очищаем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the Assign Type.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={() => { setError(''); handleClose(); }} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Add a new Assignment Type:</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>



                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={atypeValue}
                            onChange={e => setATypeValue(e.target.value)}
                            placeholder="Enter new Assignment Type"
                            disabled={loading}
                        />
                    </Form>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addAssType}
                        disabled={!atypeValue.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Add in DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});


export default CreateAssignType;